import React, { useMemo } from 'react';

/**
 * Lightweight CSS-only confetti burst. Renders a fixed set of falling pieces
 * once; parent controls mount/unmount. No dependencies.
 */
const COLORS = ['#f97316', '#f59e0b', '#ef4444', '#ec4899', '#8b5cf6', '#22c55e', '#3b82f6'];

const Confetti = ({ count = 80 }) => {
  const pieces = useMemo(() => Array.from({ length: count }, (_, i) => ({
    left: Math.random() * 100,
    delay: Math.random() * 0.6,
    duration: 1.8 + Math.random() * 1.4,
    color: COLORS[i % COLORS.length],
    size: 6 + Math.random() * 6,
    rotate: Math.random() * 360,
  })), [count]);

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden z-[60]" aria-hidden="true" data-testid="confetti">
      <style>{`
        @keyframes lumera-confetti-fall {
          0% { transform: translateY(-10%) rotate(0deg); opacity: 1; }
          100% { transform: translateY(120%) rotate(720deg); opacity: 0; }
        }
      `}</style>
      {pieces.map((p, i) => (
        <span
          key={i}
          style={{
            position: 'absolute',
            top: '-5%',
            left: `${p.left}%`,
            width: p.size,
            height: p.size * 0.4,
            background: p.color,
            transform: `rotate(${p.rotate}deg)`,
            borderRadius: 1,
            animation: `lumera-confetti-fall ${p.duration}s ${p.delay}s ease-in forwards`,
          }}
        />
      ))}
    </div>
  );
};

export default Confetti;
